import './style.scss';
import { render } from '@wordpress/element';
import App from "./App";

render(<App />, document.getElementById('acb_admin_chat_box'));